import React from "react";
import { ChevronRightIcon } from "@picklebet/ui";
import { MethodRow } from "../../method-row/MethodRow";
import * as styles from "./DestinationOption.module.scss";
import type { DestinationMethodDescriptor } from "features/wallet/components/deposit/types";

type DestinationOptionProps = {
  destination: DestinationMethodDescriptor;
  onNavigate: (stepName: string) => void;
};

export const DestinationOption = ({
  destination,
  onNavigate,
}: DestinationOptionProps) => {
  return (
    <MethodRow
      as="button"
      className={styles.destination}
      icon={<destination.Icon />}
      label={destination.label}
      trailing={
        <span className={styles.chevron}>
          <ChevronRightIcon />
        </span>
      }
      onClick={() => onNavigate(destination.destination.name)}
    />
  );
};
